module.exports = __webpack_public_path__ + "img/frame (213).5b315cae.jpg";